import { GISServiceTypes } from '../gisServicesTypes';
import { LayerLoader } from './LayerLoader';

export const geocodeLoader: LayerLoader = {
  shouldUseLoader(service) {
    return service.service_type == GISServiceTypes.geocode;
  },
  async load() {
    // The Geocoding service isn't really a map layer; just let it be.
    return [];
  },
};
